import React, { memo } from 'react'
import { Grid } from '@mui/material'

import Docs from './Docs'
import ViewAPI from './ViewAPI'
import PageContainer from '../shared/PageContainer/PageContainer'
import TokenInfo from './TokenInfo'
import LWA from './LWA'
import BrandAPI from './BrandAPI'
import DisplayAlerts from '../setup/common/DisplayAlerts'
import ImportantNote from '../shared/ImportantNote/ImportantNote'
import { INTEGRATION_OPTIONS_GUIDE_URL } from '../../util/support.helpers'

const Integration = ({
  onToggleDisplayKey,
  onDeleteAPIKey,
  onCopyAPIKey,
  isDashboardSetupReady,
  tokenProfile,
  onCloseImportantNote,
  hideIntegrationNote,
  onGetAPIKey,
  apiKeysProfile: { apiKeys },
  apiKeyState,
  onClickLWASetup,
  billingProfile,
  changeTokenState,
  onFormSubmit,
  exchangeTxCount,
  t
}) => {
  const showImportantNote = (
    <ImportantNote
      t={t}
      title='developers.important-note'
      guideUrl={INTEGRATION_OPTIONS_GUIDE_URL}
      onClose={onCloseImportantNote}
      closedImportantNote={hideIntegrationNote}
    />
  )
  return (
    <PageContainer title={t('sidebar.integration')}>
      <DisplayAlerts
        isDashboardSetupReady={isDashboardSetupReady}
        tokenStatus={tokenProfile.status}
        subscribedPackage={billingProfile.subscribedPackage}
        t={t}
      />
      {!hideIntegrationNote && showImportantNote}
      <Grid container>
        <Grid item xs={12} padding={2}>
          <Grid container spacing={4}>
            <Grid item xs={12} lg={5}>
              <Docs t={t} />
            </Grid>
            <Grid item xs={12} lg={7}>
              <ViewAPI
                apiKeys={apiKeys}
                onToggleDisplayKey={onToggleDisplayKey}
                onDeleteAPIKey={onDeleteAPIKey}
                onCopyAPIKey={onCopyAPIKey}
                onGetAPIKey={onGetAPIKey}
                isDashboardSetupReady={isDashboardSetupReady}
                apiKeyState={apiKeyState}
                exchangeTxCount={exchangeTxCount}
                t={t}
              />
            </Grid>
            <Grid item xs={12}>
              <TokenInfo
                isDashboardSetupReady={isDashboardSetupReady}
                t={t}
                tokenProfile={tokenProfile}
                lockContent={!isDashboardSetupReady}
                dispatchAction={changeTokenState}
                onFormSubmit={onFormSubmit}
              />
            </Grid>
            <Grid item xs={12} lg={6}>
              <LWA t={t} onClickLWASetup={onClickLWASetup} />
            </Grid>
            <Grid item xs={12} lg={6}>
              <BrandAPI t={t} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {hideIntegrationNote && showImportantNote}
    </PageContainer>
  )
}

export default memo(Integration)
